<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">金刚经中的四句精华之作</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       《金刚经》从印度传入中国后，自东晋时期到唐朝共有六个译本，其中玄奘所译的《能断金刚般若波罗蜜多经》占据着大乘佛教所奉持经典的三分之一。
       《金刚经》的主要目的在于让我们认识宇宙一切现象的本质，以“空”的智慧，破凡夫所见的一切法，而不是去滋长一切法，断除人的各种颠倒梦想。
       同时《金刚经》又是一部福德之经，此经是佛家的重要经典，经中有也许多让人顿悟的句子。就像经里所说“要去做善法，而又要不执着。”我想这或许就是金刚经的智慧，今天小娘子就来和大家分享一下《金刚经》中的四句精华之作，希望每一句，都能让你开悟。
       

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      一、所作福德，不应贪著菩萨不以求福德之心去行善，认为自己所做为应做之事，释迦牟尼佛将他四十九年所说的要舍，不放在心上，不求回报，这就是不应贪著。诸佛菩萨都在行功德，有好处，也不领受。
      所谓布施法门所说就是这个道理，对于自己所做的福报功德，不起贪求之心，做了就做了，不住不著。
      
      

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       二：凡所有相，皆是虚妄这句话的意思是，一切我们所能够看到的相，其实都是自己内心所构建出来的假相，梦中镜、水中月，人是虚妄的，所看之事也皆虚妄。
       如果看的时候坚守本心，不被它的外表所迷惑，能够分辨是非，那么就能达到如来的境地了。如同《心经》所言：色即是空，空即是色。所谓相，其实都是空的，是不实的，参悟“相”中之“空”，方能明心见性。 
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       三：知我说法，如筏喻者。法尚应舍，何况非法，当我们明白了事物存在的空相后，才会明白，所谓佛法，无非是帮助人们解忧除惑，杯满则溢、行过则弃。佛法都需要舍弃，那更别说佛法以外的事物了，重心在于放下执着，舍弃后才能收获更多，才方能明白事物“空”理。
       
       

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       四：若以色见我，以音声求我，是人行邪道，不能见如来修行的人，要明白若有人想以“有相”求得“无相”的佛果是不现实。如果有人说我见到什么佛了，或我听到了佛祖的声音，是不是证明我证悟成佛了，这样思想也是不正确的。去掉妄想执著，是故空中无色，才能见如来。
       “一切众生，皆具如来智慧德相”在佛看来，所有的人，都是可以修行的。只是修行无难事，所难在一心，相信大家只要一心修行，迟早开悟。
      </p>
      

    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/fo/2.vue